import _taggedTemplateLiteral from "/var/jenkins_home/workspace/_landing-style-extraction_master/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { css } from 'styled-components';
export var defaultBreakpoints = {
  huge: '1440px',
  large: '1170px',
  medium: '768px',
  small: '450px'
};

function getSizeFromBreakpoint(breakpointValue) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var adjustment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (breakpoints[breakpointValue]) {
    return "".concat(parseInt(breakpoints[breakpointValue], 10) + adjustment, "px");
  }

  if (parseInt(breakpointValue, 10)) {
    return breakpointValue;
  } // eslint-disable-next-line


  console.error('styled-media-query: No valid breakpoint or size specified for media.');
  return '0';
}

var lessThan = function lessThan(breakpoint) {
  return function () {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media (max-width: ", ") {\n    ", "\n  }\n"])), getSizeFromBreakpoint(breakpoint, defaultBreakpoints, -0.02), css.apply(void 0, arguments));
  };
};

var greaterThan = function greaterThan(breakpoint) {
  return function () {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  @media (min-width: ", ") {\n    ", "\n  }\n"])), getSizeFromBreakpoint(breakpoint, defaultBreakpoints), css.apply(void 0, arguments));
  };
};

var between = function between(firstBreakpoint, secondBreakpoint) {
  return function () {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  @media (min-width: ", ") and\n    (max-width: ", ") {\n    ", "\n  }\n"])), getSizeFromBreakpoint(firstBreakpoint, defaultBreakpoints), getSizeFromBreakpoint(secondBreakpoint, defaultBreakpoints, -0.02), css.apply(void 0, arguments));
  };
};

export default {
  lessThan: lessThan,
  greaterThan: greaterThan,
  between: between
};